import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/background.png'


const _withScopeId = n => (_pushScopeId("data-v-4fcc6a63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-sidebar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  alt: "Event image",
  src: _imports_0
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"none"} }, "Exhibiting", -1))
const _hoisted_6 = { class: "list-items" }

import { IEventV2 } from "@/models/event";
import { PropType, onMounted, ref } from "vue";
import {
  homeOutline,
  enterOutline,
  peopleOutline,
  settingsOutline,
} from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventSidebar',
  props: {
  event: Object as PropType<IEventV2>,
},
  setup(__props) {

const props = __props;



const menuItems = ref([] as { name: string; icon: string; route: string }[]);

onMounted(() => {
  if (props.event) {
    menuItems.value = [
      {
        name: "Home",
        icon: homeOutline,
        route: "home",
      },
      {
        name: "Check-in",
        icon: enterOutline,
        route: "scan",
      },
      {
        name: "Visitors",
        icon: peopleOutline,
        route: "visitors",
      },
      {
        name: "Setup",
        icon: settingsOutline,
        route: "settings",
      },
    ];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.event)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.event.image && __props.event.image !== '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.event.image,
                alt: "Event image"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-desktop",
                style: {"align-items":"center"},
                key: i
              }, [
                _createVNode(_component_router_link, {
                  style: {"text-decoration":"none","color":"inherit"},
                  to: item.route
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: item.icon
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})